<template>
    <a-modal :title="titlePrefix" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
             :confirm-loading="confirmLoading" @ok="onSubmit" @cancel="onClose" width="65%">
        <a-form layout="horizontal" ref="ruleForm" :model="form" :rules="rules" @submit="onSubmit">
            <!--可编辑区域 start-->
            <div class="hidden">
                <a-form-item label="id" name="id">
                    <a-input v-model:value="form.id"/>
                </a-form-item>
            </div>
            <a-row :gutter="[24,8]">
                <a-col :span="24">
                    <a-form-item label="图片" name="icon">
                        <ImgUpload v-model:value="form.icon"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="版权名称" name="copyrightName">
                        <a-input v-model:value="form.copyrightName" placeholder="请输入版权名称"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="授权方式" name="accredit">
                        <DictSelect v-model:value="form.accredit"
                    :dict-name="policy.INTELLECTUALSUBSIDY_GET" placeholder="请选择" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="版权行业类型" name="copyrightType">
                        <DictSelect
                            v-model:value="form.copyrightType"
                            :dict-name="innovation.PROJECT_TYPE"
                            placeholder="请选择"
                        />
                    </a-form-item>
                </a-col>

<!--                <a-col :span="12">-->
<!--                    <a-form-item label="保护范围分析" name="rangeAnalysis">-->
<!--                        <a-input v-model:value="form.rangeAnalysis"/>-->
<!--                    </a-form-item>-->
<!--                </a-col>-->

                <a-col :span="12">
                    <a-form-item label="版权号" name="versionCode">
                        <a-input v-model:value="form.versionCode" placeholder="请输入版权号"/>
                    </a-form-item>
                </a-col>
<!--                <a-col :span="12">-->
<!--                    <a-form-item label="版权持有人" name="brandHolder">-->
<!--                        <a-input v-model:value="form.brandHolder"/>-->
<!--                    </a-form-item>-->
<!--                </a-col>-->
<!--                <a-col :span="12">-->
<!--                    <a-form-item label="联系电话" name="linkPhone">-->
<!--                        <a-input v-model:value="form.linkPhone"/>-->
<!--                    </a-form-item>-->
<!--                </a-col>-->
<!--                <a-col :span="12">-->
<!--                    <a-form-item label="初审公告期号" name="firstCode">-->
<!--                        <a-input v-model:value="form.firstCode"/>-->
<!--                    </a-form-item>-->
<!--                </a-col>-->
                    <a-col :span="12">
                        <a-form-item label="授权日期" name="firstPublishDate">
                            <DatePicker v-model:value="form.firstPublishDate" placeholder="请输入授权日期" style="width: 100%"/>
                        </a-form-item>
                    </a-col>
<!--                <a-col :span="12">-->
<!--                    <a-form-item label="注册公告日期" name="announcementTime">-->
<!--                        <DatePicker v-model:value="form.announcementTime" placeholder="请输入认定时间" style="width: 100%"/>-->
<!--                    </a-form-item>-->
<!--                </a-col>-->
                <a-col :span="12">
                    <a-form-item label="创作完成时间" name="创作完成时间">
                        <DatePicker v-model:value="form.buildCompleteDate" placeholder="请输入创作完成时间" style="width: 100%"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="版权范围" name="copyrightRange">
                        <multiple-select v-model:value="form.copyrightRange" :options="options" title-name="name" value-name="id"/>
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="版权声明" name="copyrightState">
                        <TinymceEditor v-model:value="form.copyrightState"/>
                    </a-form-item>
                </a-col>
                <!--可编辑区域 end-->
            </a-row>
        </a-form>

    </a-modal>
</template>
<script>
    // import dataCheck from "@/utils/dataCheck";
    import {formMixin} from "@/mixins";
    import {common_controller} from "@/api/commonService";
    import {copyrightApi} from "@/api/knowledge";
    import DictSelect from "@/components/other/DictSelect";
    import {policy,innovation} from "@/config/variableConfig";
    import TinymceEditor from "@/components/form/editor/TinymceEditor";

    export default {
        name: "AddOrEditModal",
        components: {TinymceEditor, DictSelect},

        mixins: [formMixin],
        data() {
            return {
                innovation,
                policy,
                form: {
                    id: null,
                    copyrightRange: null,
                    copyrightState: null,
                    copyrightName: null,
                    accredit: null,
                    versionCode: null,
                    buildCompleteDate: null,
                    firstPublishDate: null,
                    brandName: null,
                    copyrightType: null,
                    icon:null,
                    description: null,
                    scopeApplication: null,
                    brandNumber: null,
                    firstTime: null,
                    firstCode: null,
                    announcementTime: null,
                    brandHolder: null,
                    linkPhone: null,
                    startTime: null,
                    rangeAnalysis: null,

                },
                rules: {
                    id: [],
                    copyrightRange: [],
                    copyrightState: [],
                    copyrightName: [],
                    accredit: [],
                    versionCode: [],
                    buildCompleteDate: [],
                    firstPublishDate: [],
                    brandName: [],
                    copyrightType: [],
                    icon:[],
                    description: [],
                    scopeApplication: [],
                    brandNumber: [],
                    firstTime: [],
                    firstCode: [],
                    announcementTime: [],
                    brandHolder: [],
                    linkPhone: [],
                    startTime: [],
                    rangeAnalysis: [],
                },
                submitUrl: copyrightApi.saveOrUpdate
            }
        },
        mounted() {
            this.getDict()
        },
        methods: {
            
            getDict(){
                this.getAction({
                    url:common_controller.getDictDataByGroupNumber,
                    params: {
                        groupNumbers: "copyright_scope"
                    }
                }).then(res=>{
                    this.options = res
                })
            },
        },
    }
</script>
<style scoped lang="less">
</style>
